import { render, staticRenderFns } from "./alarmpdialog.vue?vue&type=template&id=2065715e&scoped=true"
import script from "./alarmpdialog.vue?vue&type=script&lang=js"
export * from "./alarmpdialog.vue?vue&type=script&lang=js"
import style0 from "./alarmpdialog.vue?vue&type=style&index=0&id=2065715e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2065715e",
  null
  
)

export default component.exports